<aside class="left-sidebar" id="sidebar">
  <div>
    <div class="brand-logo d-flex align-items-center justify-content-between">
      <div class="text-nowrap logo-img cursor-pointer">
        <img src="assets\images\PeriscopeLogo.png" alt="Image" class="" />
      </div>
      <div class="close-btn d-xl-none d-block sidebartoggler cursor-pointer" id="sidebarCollapse"
        (click)="closeSidebar()">
        <i class="ti ti-x fs-6"></i>
      </div>
    </div>
    <nav class="sidebar-nav scroll-sidebar" data-simplebar="">
      <ul id="sidebarnav">


        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between" routerLink="/customer" routerLinkActive="active"
            (click)="closeSidebar()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                  <i class="bi bi-person"></i>
              </span>
              <span class="hide-menu">Customers</span>
            </div>
          </a>
        </li>

        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between" routerLink="/customerSite" routerLinkActive="active"
            (click)="closeSidebar()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <i class="bi bi-building"></i>
              </span>
              <span class="hide-menu">Customer Sites</span>
            </div>
          </a>
        </li>


        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between" routerLink="/product" routerLinkActive="active"
            (click)="closeSidebar()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                 <i class="bi bi-bag"></i>
              </span>
              <span class="hide-menu">Products</span>
            </div>
          </a>
        </li>

        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between" routerLink="/productPlan" routerLinkActive="active"
            (click)="closeSidebar()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                 <i class="bi bi-list-task"></i>
              </span>
              <span class="hide-menu">Product Plans</span>
            </div>
          </a>
        </li>


        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between" routerLink="/subscription" routerLinkActive="active"
            (click)="closeSidebar()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                 <i class="bi bi-arrow-repeat "></i>
              </span>
              <span class="hide-menu">Subscriptions</span>
            </div>
          </a>
        </li>


        <hr class="sidebar-bottom-divider" />
        <li class="sidebar-item">
          <a class="sidebar-link justify-content-between cursor-pointer" (click)="logout()" aria-expanded="false">
            <div class="d-flex align-items-center gap-3">
              <span class="d-flex">
                <img src="assets/icons/hugeicons_logout-05.png" />
              </span>
              <span class="hide-menu">Logout</span>
            </div>
          </a>
        </li>

        <hr class="sidebar-bottom-divider" />
      </ul>
    </nav>

    <div class="powered-by-image text-center p-3">
      <small class="fw-bold text-black me-2">Powered by</small>
      <img src="assets/images/dnvLogo.png" alt="DNV Logo" class="img-fluid dnv-img">
    </div>
  </div>
</aside>